import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function routeReducer(state = initialState.prevRoute, action) {
  switch (action.type) {
    case types.SET_PREV_ROUTE_SUCCESS:
      return action.route;
    default:
      return state;
  }
}
